/**
 * Created by qlong on 9/9/2016.
 */
export function addCategory(category){
    return {
        type: "ADD_CATEGORY",
        payload: category,
    }
}

export function removeCategory(category){
    return {
        type: "REMOVE_CATEGORY",
        payload: category,
    }
}

export function setSelectedOption(selectedOption){
    return {
        type: "SET_SELECTED_OPTION",
        payload: selectedOption,
    }
}

export function addAttributes(attributes){
    return {
        type: "ADD_ATTRIBUTES",
        payload: attributes,
    }
}

export function setAttributes(attributes){
    return {
        type: "SET_ATTRIBUTES",
        payload: attributes,
    }
}

export function deleteCategoryColor(index){
    return {
        type: "DELETE_CATEGORY_COLOR",
        payload: index,
    }
}

export function setCategoryColor(index, color){
    return {
        type: "SET_CATEGORY_COLOR",
        payload: {color: color, index: index}
    }
}

export function addCategoryColorSet(color){
    return {
        type: "ADD_CATEGORY_COLOR_SET",
        payload: color,
    }
}

export function popCategoryColorSet(){
    return {
        type: "POP_CATEGORY_COLOR_SET",
        payload: null,
    }
}

export function clearFilters(){
    return {
        type: "CLEAR_FILTERS",
        payload: null,
    }
}

export function setFirstLoadFalse(){
    return {
        type: "SET_FIRST_LOAD_FALSE",
        payload: null,
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/filterActions.js
 **/